import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 *
 * Automatically scrolls to the top of the page when the route changes.
 * This mimics the default browser behavior of traditional multi-page apps.
 *
 * Usage: Place inside <BrowserRouter> but outside <Routes>
 *
 * @example
 * ```tsx
 * <BrowserRouter>
 *   <ScrollToTop />
 *   <Routes>
 *     <Route path="/" element={<Home />} />
 *   </Routes>
 * </BrowserRouter>
 * ```
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top whenever pathname changes
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
